import { canTrack, GTMTrack } from '@utils/dataLayer';
import { galleryState as state } from './galleryState';
import { reloadAds } from '@utils/advertisement';
import { callPVMarfeel } from '@utils/marfeel';

let isHandlingArrow = false;
let isHandlingKeyboard = false;

export const handleCarouselArrows = (e: Event) => {
  if (isHandlingArrow) return;
  isHandlingArrow = true;

  const arrowButton = e.currentTarget as HTMLElement;

  if (state.getIsMobile()) {
    isHandlingArrow = false;
    return;
  }

  if (canTrack()) {
    GTMTrack(
      `gallery_${
        (arrowButton as HTMLButtonElement).dataset.glideDir === '>' ? 'next' : 'previous'
      }`,
      {
        gallery: {
          position: state.getActiveItem(),
        },
      }
    );
    reloadAds();
    callPVMarfeel();
  }
  setTimeout(() => {
    isHandlingArrow = false;
  }, 400);
};

// Handler pro klávesové šipky - stejný přístup jako u handleCarouselArrows
export const handleKeyboardArrows = (e: KeyboardEvent) => {
  if (isHandlingKeyboard || !state.getIsDesktop() || !state.getIsSlideOrScroll()) return;

  // Reagujeme pouze na šipky vlevo/vpravo
  if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

  e.preventDefault();
  e.stopPropagation();

  isHandlingKeyboard = true;

  // Kontrola na zoom modál
  const zoomModal: HTMLElement | null = document.querySelector('[data-gallery-zoom-modal]');
  const isZoomVisible = zoomModal && window.getComputedStyle(zoomModal).display !== 'none';

  // Pokud není aktivní zoom, provedeme reload reklam
  if (!isZoomVisible && canTrack()) {
    // Použijeme stejný způsob trackování jako u kliknutí na šipky
    GTMTrack(
      `gallery_${e.key === 'ArrowRight' ? 'next' : 'previous'}`,
      {
        gallery: {
          position: state.getActiveItem(),
        },
      }
    );

    // Krátká prodleva pro dokončení přechodu
    setTimeout(() => {
      reloadAds();
      callPVMarfeel();
    }, 100);
  }

  // Debounce pro omezení opakovaného volání při držení klávesy
  setTimeout(() => {
    isHandlingKeyboard = false;
  }, 400);
};

export const galleryClose = () => {
  const closeElements = document.querySelectorAll('[data-gallery-close]');
  closeElements.forEach((closeElement) => {
    closeElement.addEventListener('click', () => {
      GTMTrack('gallery_close');
    });
  });

  return () => {
    closeElements.forEach((closeElement) => {
      closeElement.removeEventListener('click', () => {
        GTMTrack('gallery_close');
      });
    });
  };
};

export const galleryGTMTracking = () => {
  // Máme didomi souhlas?
  if (!canTrack()) return;

  // Otevření galerie
  GTMTrack('gallery_open');

  // Zavření galerie
  galleryClose();
};
